export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7fa1e667374a97e7182e49dd951df23aaaf35f936f&name=fetchTypeahead!'